import {addActionSheet, removeActionSheet} from './modules/action_sheet.js';
import "./modules/ajax";
import "./modules/formtools";
import {Alert, Annoy, Confirm} from './modules/annoy.js';
import {initializeComponents} from './modules/initializer.js';
import {closeActiveMenus, openMenu} from './modules/menu.js';
import {ajaxModal, getModal, getModalVar} from './modules/modal.js';
import {initializeLazyQueue} from './modules/lazy_queue.js';
import {addOnReady, triggerOnReady} from './modules/ready_stack';
import {addToast, removeAllToasts, removeToast} from './modules/site_toast.js';
import {nl2br, trim} from './modules/strings.js';
import {copyTextToClipboard, generateGuid, hideSpinner, isNull, randomNumber, showSpinner} from './modules/utility.js';
import {getAppUrl, getPageVar, getPageVars, getSiteUrl, setPageVars} from './modules/variable.js';

const bundle = {
    fnc: {
        // action_sheet
        addActionSheet, removeActionSheet,

        //annoy
        Alert, Annoy, Confirm,

        // initializer
        initializeComponents,

        // menu
        closeActiveMenus, openMenu,

        // modal
        ajaxModal, getModal, getModalVar,

        // lazy_queue
        initializeLazyQueue,

        // ready_stack
        addOnReady, triggerOnReady,

        // site_toast
        addToast, removeAllToasts, removeToast,

        // strings
        nl2br, trim,

        // utility
        copyTextToClipboard, generateGuid, hideSpinner, isNull, randomNumber, showSpinner,

        // variable
        getAppUrl, getPageVar, getPageVars, getSiteUrl, setPageVars
    },
    vars: {
        spinner_click_counter: 0
    }
};

window.maggieland = new Proxy(bundle, {
    get: function (target, name) {
        if (name in target) {
            // Normal access, property/method exists
            return target[name];
        } else if (name in target.fnc) {
            // Allow functions to be called without specifying the .fnc portion
            return target.fnc[name];
        }
    }
});

